/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_Save_Cancelled_ErrorInputs */



/**
* | output |
* | --- |
* | "Saving project was cancelled" |
*
* @param {Explorer_Display_Save_Cancelled_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_save_cancelled_error = /** @type {((inputs?: Explorer_Display_Save_Cancelled_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Save_Cancelled_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrement du projet annule")
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Rettungsprojekt wurde abgesagt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il salvataggio del progetto è stato annullato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проект спасения был отменен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El proyecto de ahorro fue cancelado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("拯救项目被取消")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトの保存はキャンセルされました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बचत परियोजना रद्द कर दी गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O projeto de poupança foi cancelado.")
	return /** @type {LocalizedString} */ ("Saving project was cancelled")
});